import script from "./bulkUpdateModel.vue?vue&type=script&setup=true&lang=jsx"
export * from "./bulkUpdateModel.vue?vue&type=script&setup=true&lang=jsx"

const __exports__ = script;

export default __exports__